<template>
  <div class="py-1">
    <label for="{{label}}" class="block text-xss  text-gray-700">{{label}}</label>
    <div class="mt-1 flex items-center relative w-[135px]">
      <input type="text" :value="value" @input="updateValue" class="defaultInput" :disabled="disabled" />
      <input type="color" :value="value" @input="updateValue" class="absolute right-2" id="head" name="head" :disabled="disabled" />
    </div>
    <label class="pt-1 block text-xs font-light text-gray-700">{{info}}</label>
  </div>
</template>

<script>

export default {
    name: 'InputColorPicker',
    props: {
        value: {
            type: String,
            default: '#ffffff'
        },
        label: String,
        info: String,
        disabled: Boolean,
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        },
    },
    created() {
      this.$emit('update:modelValue', this.value);
    },
}
</script>